/**
 * relative height function
 * @param {Number} px desired vertical height, in pixels, of a 1080px high screen
 * @returns {String} relative height equivalent of px input
 */
const rh = (px) => `max(${(100 * px) / 1080}vh, ${px / 2}px)`

export default rh
